import {
  AdminWorkflowsApi,
  AttachmentsApi,
  AutocompleteControllerApi,
  CategoryControllerApi,
  ClientAddressManagementApi,
  ClientArticlesApi,
  ClientAuctionControllerApi,
  ClientAuctionLimitsApi,
  ClientBasketManagementApi,
  ClientDashboardApi,
  CustomProductControllerApi,
  ClientFavoritesControllerApi,
  ClientLoVControllerApi,
  ClientManualSupplierControllerApi,
  ClientMessagesApi,
  ClientNotificationPreferencesApi,
  ClientStockReceiptsApi,
  ClientPriceEvidenceApi,
  ClientOrderControllerApi,
  ClientPreferredDeliveryControllerApi,
  ClientProductControllerApi,
  ClientProductTileControllerApi,
  ClientScheduledOrdersApi,
  ClientShoppingListsManagementApi,
  ClientUserManagementApi,
  DeliveryCalendarApi,
  DeliveryExportImportApi,
  DeliveryImportApi,
  DeliveryWindowsManagementApi,
  QuickOrderActionApi,
  ScheduledOrderActionApi,
  SearchControllerControllerApi,
  SupplierDeliveryWindowsApi,
  SupplierLOVApi,
  SupplierMessagesApi,
  SupplierOrderControllerApi,
  SupplierPricesApi,
  SupplierProductDetailApi,
  SupplierProductsApi,
  TaskControllerApi,
  WorkflowControllerApi,
} from '@api/generated/search-service';
import { AuthenticationApi, Configuration, DemoInvitationApi } from '@api/generated/bff';
import axios from 'axios';
import {
  AdminArticleControllerApi,
  AdminAuctionControllerApi,
  AdminCategoryManagementApi,
  AdminCustomerManagementApi,
  AdminLoVManagementApi,
  AdminNotificationPreferencesApi,
  AdminOrderControllerApi,
  AdminCartControllerApi,
  AdminOrganizationCatalogControllerApi,
  AdminOrganizationImportExportApi,
  AdminOrganizationManagementApi,
  AdminDeliveryWindowManagementApi,
  AdminEsQueryLogControllerApi,
  AdminIndexManagementApi,
  AdminProductDetailApi,
  AdminProductImagesManagementApi,
  AdminProductManagementApi,
  AdminProductSearchNameApi,
  AdminRoleManagementApi,
  AdminSecurityGroupManagementApi,
  AdminUserManagementApi,
  AdminEmailRequestsApi,
  AdminDemoInvitationsApi,
  AdminResolvedEmailsApi,
  AdminSyncRequestsApi,
  AdminEnvCheckApi,
  AdminImageImportControllerApi,
  AdminImageDeleteControllerApi,
  AdminInitialLoadControllerApi,
  AdminNpLoadControllerApi,
  AdminCatalogImportApi,
  AdminOrganizationMergeApi,
  AdminContractGroupsApi,
  AdminReportsApi,
  AdminUserReportsApi,
  AdminDeliveryImportApi,
  AdminPriceCorrectionApi,
  AdminOrganizationSyncApi,
  AdminNpSyncApi,
  AdminSupplierReidApi,
  AdminSyncDiffControllerApi,
  AdminSyncResultControllerApi,
  AdminSyncBatchesApi,
} from '@api/generated/portal-be-admin';
import { CatalogApi } from '@api/generated/pecosta-search-service';
import {
  AuctionedItemsApi,
  MyReportsApi,
  PriceEvidenceApi,
  PurchaseBreakdownApi,
  PurchaseOverviewApi,
  PurchaseSavingsApi,
  ReportsApi,
  WinningItemsApi,
} from '@api/generated/reporting-api';

export const sharedAxios = axios.create({});

sharedAxios.interceptors.response.use(
  r => r,
  e => {
    if (e.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      window.location.href = '/login?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
    }
    return Promise.reject(e);
  },
);

const configSearch = new Configuration({
  basePath: '/bff/services/search-service',
});

// Samostatná Quarkus catalog-service přes BFF proxy.
const catalogServiceBase = '/bff/services/catalog-service';

// SearchControllerControllerApi.autoComplete volá `{basePath}/api/search/autocomplete` –
// cesta odpovídá endpointu nové služby, basePath stačí kořenová.
const configCatalogService = new Configuration({
  basePath: catalogServiceBase,
});

// AutocompleteControllerApi.search volá `{basePath}/{organizationId}/{portalId}`
// (portal-backend má chybu v @RestController), proto se do basePath zapéká
// cesta `/api/autocomplete`, ať výsledek sedne na endpoint nové služby.
const configCatalogAutocomplete = new Configuration({
  basePath: `${catalogServiceBase}/api/autocomplete`,
});

// Quarkus reporting-api (data pro reporty nad ClickHouse) přes BFF proxy.
const configReportingApi = new Configuration({
  basePath: '/bff/services/reporting-api',
});

const adminConfig = new Configuration({
  basePath: '/bff/services/portal-be-admin',
});

const bffConfig = new Configuration({
  basePath: '/bff',
});

export const searchApi = new SearchControllerControllerApi(configSearch, undefined, sharedAxios);
// legacy kombinovaný autocomplete (/api/search/autocomplete) – přes catalog-service
export const searchAutocompleteApi = new SearchControllerControllerApi(configCatalogService, undefined, sharedAxios);
// katalog (/catalog/{portalId}/{buyerId}) – přes catalog-service
export const catalogApi = new CatalogApi(configCatalogService, undefined, sharedAxios);
export const categoryApi = new CategoryControllerApi(configSearch, undefined, sharedAxios);
// reporty (/api/reports/...) – přes reporting-api
export const reportsApi = new ReportsApi(configReportingApi, undefined, sharedAxios);
// nabídka reportů a sestavy s vlastním tvarem odpovědi (evidence nákupu)
export const myReportsApi = new MyReportsApi(configReportingApi, undefined, sharedAxios);
export const purchaseOverviewApi = new PurchaseOverviewApi(configReportingApi, undefined, sharedAxios);
export const winningItemsApi = new WinningItemsApi(configReportingApi, undefined, sharedAxios);
export const auctionedItemsApi = new AuctionedItemsApi(configReportingApi, undefined, sharedAxios);
export const purchaseSavingsApi = new PurchaseSavingsApi(configReportingApi, undefined, sharedAxios);
export const purchaseBreakdownApi = new PurchaseBreakdownApi(configReportingApi, undefined, sharedAxios);
export const priceEvidenceApi = new PriceEvidenceApi(configReportingApi, undefined, sharedAxios);

export const deliveryWindowsManagementApi = new DeliveryWindowsManagementApi(configSearch, undefined, sharedAxios);
export const deliveryExportImportApi = new DeliveryExportImportApi(configSearch, undefined, sharedAxios);
export const deliveryImportApi = new DeliveryImportApi(configSearch, undefined, sharedAxios);

export const clientAddressManagementApi = new ClientAddressManagementApi(configSearch, undefined, sharedAxios);
export const taskControllerApi = new TaskControllerApi(configSearch, undefined, sharedAxios);
export const clientUserManagementApi = new ClientUserManagementApi(configSearch, undefined, sharedAxios);
export const clientAuctionControllerApi = new ClientAuctionControllerApi(configSearch, undefined, sharedAxios);
export const clientAuctionLimitsApi = new ClientAuctionLimitsApi(configSearch, undefined, sharedAxios);
export const clientBasketManagementApi = new ClientBasketManagementApi(configSearch, undefined, sharedAxios);
export const clientDashboardApi = new ClientDashboardApi(configSearch, undefined, sharedAxios);
export const clientShoppingListsManagementApi = new ClientShoppingListsManagementApi(configSearch, undefined, sharedAxios);
export const clientFavoritesControllerApi = new ClientFavoritesControllerApi(configSearch, undefined, sharedAxios);
export const deliveryCalendarApi = new DeliveryCalendarApi(configSearch, undefined, sharedAxios);
export const attachmentsApi = new AttachmentsApi(configSearch, undefined, sharedAxios);
export const clientOrderControllerApi = new ClientOrderControllerApi(configSearch, undefined, sharedAxios);
export const clientProductControllerApi = new ClientProductControllerApi(configSearch, undefined, sharedAxios);
export const clientProductTileControllerApi = new ClientProductTileControllerApi(configSearch, undefined, sharedAxios);
export const clientManualSupplierControllerApi = new ClientManualSupplierControllerApi(configSearch, undefined, sharedAxios);
export const clientMessagesApi = new ClientMessagesApi(configSearch, undefined, sharedAxios);
export const clientLovApi = new ClientLoVControllerApi(configSearch, undefined, sharedAxios);
export const clientPreferredDeliveryControllerApi = new ClientPreferredDeliveryControllerApi(configSearch, undefined, sharedAxios);
export const clientAutocompleteControllerApi = new AutocompleteControllerApi(configCatalogAutocomplete, undefined, sharedAxios);
export const clientArticlesApi = new ClientArticlesApi(configSearch, undefined, sharedAxios);
export const clientNotificationPreferencesApi = new ClientNotificationPreferencesApi(configSearch, undefined, sharedAxios);
// ruční zadávání příjmu na sklad (zdroj pravdy je Postgres, do reportingu to kopíruje job)
export const clientStockReceiptsApi = new ClientStockReceiptsApi(configSearch, undefined, sharedAxios);
// detail reportu Evidence cen – dostupné ceny jsou v portal DB, ne v reportingu
export const clientPriceEvidenceApi = new ClientPriceEvidenceApi(configSearch, undefined, sharedAxios);
export const customProductControllerApi = new CustomProductControllerApi(configSearch, undefined, sharedAxios);

// BFF API - auth
export const authenticationApi = new AuthenticationApi(bffConfig, undefined, sharedAxios);
// Pozvánka do dema — příjemce nemá session, autorizuje ho kód v odkazu.
export const demoInvitationApi = new DemoInvitationApi(bffConfig, undefined, sharedAxios);

// admin endpoints
export const adminProductImagesManagementApi = new AdminProductImagesManagementApi(adminConfig, undefined, sharedAxios);
export const adminProductManagementApi = new AdminProductManagementApi(adminConfig, undefined, sharedAxios);
export const adminOrganizationCatalogControllerApi = new AdminOrganizationCatalogControllerApi(adminConfig, undefined, sharedAxios);
export const adminOrganizationManagementApi = new AdminOrganizationManagementApi(adminConfig, undefined, sharedAxios);
export const adminDeliveryWindowManagementApi = new AdminDeliveryWindowManagementApi(adminConfig, undefined, sharedAxios);
export const adminOrganizationImportExportApi = new AdminOrganizationImportExportApi(adminConfig, undefined, sharedAxios);
export const adminEsQueryLogApi = new AdminEsQueryLogControllerApi(adminConfig, undefined, sharedAxios);
export const adminIndexApi = new AdminIndexManagementApi(adminConfig, undefined, sharedAxios);
export const adminUserApi = new AdminUserManagementApi(adminConfig, undefined, sharedAxios);
export const adminLoVManagementApi = new AdminLoVManagementApi(adminConfig, undefined, sharedAxios);
export const adminCategoryManagementApi = new AdminCategoryManagementApi(adminConfig, undefined, sharedAxios);
export const adminRoleManagementApi = new AdminRoleManagementApi(adminConfig, undefined, sharedAxios);
export const adminSecurityGroupManagementApi = new AdminSecurityGroupManagementApi(adminConfig, undefined, sharedAxios);
export const adminOrderApi = new AdminOrderControllerApi(adminConfig, undefined, sharedAxios);
export const adminCartApi = new AdminCartControllerApi(adminConfig, undefined, sharedAxios);
export const adminAuctionApi = new AdminAuctionControllerApi(adminConfig, undefined, sharedAxios);
export const adminProductDetailApi = new AdminProductDetailApi(adminConfig, undefined, sharedAxios);
export const adminCustomerManagementApi = new AdminCustomerManagementApi(adminConfig, undefined, sharedAxios);
export const adminProductSearchNameApi = new AdminProductSearchNameApi(adminConfig, undefined, sharedAxios);
export const adminArticleApi = new AdminArticleControllerApi(adminConfig, undefined, sharedAxios);
export const adminNotificationPreferencesApi = new AdminNotificationPreferencesApi(adminConfig, undefined, sharedAxios);

// supplier
export const supplierOrderControllerApi = new SupplierOrderControllerApi(configSearch, undefined, sharedAxios);
export const supplierMessagesApi = new SupplierMessagesApi(configSearch, undefined, sharedAxios);
export const supplierLOVApi = new SupplierLOVApi(configSearch, undefined, sharedAxios);
export const supplierProductsApi = new SupplierProductsApi(configSearch, undefined, sharedAxios);
export const supplierPricesApi = new SupplierPricesApi(configSearch, undefined, sharedAxios);
export const supplierDeliveryWindowsApi = new SupplierDeliveryWindowsApi(configSearch, undefined, sharedAxios);
export const supplierProductDetailApi = new SupplierProductDetailApi(configSearch, undefined, sharedAxios);

// stare API
/*
export const adminUsersApi = new AdminUserApi(config, undefined, sharedAxios);
export const adminOrganizationsApi = new AdminOrganizationApi(config, undefined, sharedAxios);
export const adminProductsApi = new AdminProductApi(config, undefined, sharedAxios);
export const adminCategoriesApi = new AdminCategoriesApi(config, undefined, sharedAxios);
export const portalApi = new PortalApi(config, undefined, sharedAxios);
*/

// admin email notifications
export const adminEmailRequestsApi = new AdminEmailRequestsApi(adminConfig, undefined, sharedAxios);
export const adminDemoInvitationsApi = new AdminDemoInvitationsApi(adminConfig, undefined, sharedAxios);
export const adminResolvedEmailsApi = new AdminResolvedEmailsApi(adminConfig, undefined, sharedAxios);
export const adminSyncRequestsApi = new AdminSyncRequestsApi(adminConfig, undefined, sharedAxios);
export const adminEnvCheckApi = new AdminEnvCheckApi(adminConfig, undefined, sharedAxios);
export const adminImageImportApi = new AdminImageImportControllerApi(adminConfig, undefined, sharedAxios);
export const adminImageDeleteApi = new AdminImageDeleteControllerApi(adminConfig, undefined, sharedAxios);
export const adminInitialLoadApi = new AdminInitialLoadControllerApi(adminConfig, undefined, sharedAxios);
export const adminSyncDiffApi = new AdminSyncDiffControllerApi(adminConfig, undefined, sharedAxios);
export const adminNpLoadApi = new AdminNpLoadControllerApi(adminConfig, undefined, sharedAxios);
export const adminCatalogImportApi = new AdminCatalogImportApi(adminConfig, undefined, sharedAxios);
export const adminDeliveryImportApi = new AdminDeliveryImportApi(adminConfig, undefined, sharedAxios);
export const adminPriceCorrectionApi = new AdminPriceCorrectionApi(adminConfig, undefined, sharedAxios);
export const adminOrganizationSyncApi = new AdminOrganizationSyncApi(adminConfig, undefined, sharedAxios);
export const adminNpSyncApi = new AdminNpSyncApi(adminConfig, undefined, sharedAxios);
export const adminSupplierReidApi = new AdminSupplierReidApi(adminConfig, undefined, sharedAxios);
export const adminSyncResultApi = new AdminSyncResultControllerApi(adminConfig, undefined, sharedAxios);
export const adminSyncBatchesApi = new AdminSyncBatchesApi(adminConfig, undefined, sharedAxios);
export const adminOrganizationMergeApi = new AdminOrganizationMergeApi(adminConfig, undefined, sharedAxios);
export const adminContractGroupsApi = new AdminContractGroupsApi(adminConfig, undefined, sharedAxios);

// reporty – katalog definic a jejich přiřazení (reporting-api níž je jen na data)
export const adminReportsApi = new AdminReportsApi(adminConfig, undefined, sharedAxios);
export const adminUserReportsApi = new AdminUserReportsApi(adminConfig, undefined, sharedAxios);

// quick action
export const quickOrderActionApi = new QuickOrderActionApi(configSearch, undefined, sharedAxios);

// plánované objednávky
export const clientScheduledOrdersApi = new ClientScheduledOrdersApi(configSearch, undefined, sharedAxios);
// veřejné schválení/zamítnutí z e-mailu (bez přihlášení)
export const scheduledOrderActionApi = new ScheduledOrderActionApi(configSearch, undefined, sharedAxios);

// workflow
export const workflowApi = new WorkflowControllerApi(configSearch, undefined, sharedAxios);
// prehled workflow definic (admin) - definice zije v portal-backendu
export const adminWorkflowsApi = new AdminWorkflowsApi(configSearch, undefined, sharedAxios);
